/* tslint:disable */
/* eslint-disable */
/**
 * Agora Livestock API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0.0 (v2)
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { APIException } from '../model';
// @ts-ignore
import { StripeSellerCreateSetupIntent } from '../model';
// @ts-ignore
import { StripeSellerRetrieveSetupIntentRequest } from '../model';
// @ts-ignore
import { StripeSetupIntent } from '../model';
// @ts-ignore
import { ValidationError } from '../model';
/**
 * SellerStripeApi - axios parameter creator
 * @export
 */
export const SellerStripeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns setup intent, along with the customer and an ephemeral key
         * @summary Creates a new setup intent
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sellerStripeCreateSetupIntentCreate: async (aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/seller/stripe/create-setup-intent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the SetupIntent and attached PaymentMethod.
         * @summary Gets the details of a setup intent
         * @param {StripeSellerRetrieveSetupIntentRequest} stripeSellerRetrieveSetupIntentRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sellerStripeRetrieveSetupIntentCreate: async (stripeSellerRetrieveSetupIntentRequest: StripeSellerRetrieveSetupIntentRequest, aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'stripeSellerRetrieveSetupIntentRequest' is not null or undefined
            assertParamExists('sellerStripeRetrieveSetupIntentCreate', 'stripeSellerRetrieveSetupIntentRequest', stripeSellerRetrieveSetupIntentRequest)
            const localVarPath = `/v2/seller/stripe/retrieve-setup-intent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(stripeSellerRetrieveSetupIntentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SellerStripeApi - functional programming interface
 * @export
 */
export const SellerStripeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SellerStripeApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns setup intent, along with the customer and an ephemeral key
         * @summary Creates a new setup intent
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sellerStripeCreateSetupIntentCreate(aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StripeSellerCreateSetupIntent>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sellerStripeCreateSetupIntentCreate(aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns the SetupIntent and attached PaymentMethod.
         * @summary Gets the details of a setup intent
         * @param {StripeSellerRetrieveSetupIntentRequest} stripeSellerRetrieveSetupIntentRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sellerStripeRetrieveSetupIntentCreate(stripeSellerRetrieveSetupIntentRequest: StripeSellerRetrieveSetupIntentRequest, aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StripeSetupIntent>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sellerStripeRetrieveSetupIntentCreate(stripeSellerRetrieveSetupIntentRequest, aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SellerStripeApi - factory interface
 * @export
 */
export const SellerStripeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SellerStripeApiFp(configuration)
    return {
        /**
         * Returns setup intent, along with the customer and an ephemeral key
         * @summary Creates a new setup intent
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sellerStripeCreateSetupIntentCreate(aaSource?: string, options?: any): AxiosPromise<StripeSellerCreateSetupIntent> {
            return localVarFp.sellerStripeCreateSetupIntentCreate(aaSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the SetupIntent and attached PaymentMethod.
         * @summary Gets the details of a setup intent
         * @param {StripeSellerRetrieveSetupIntentRequest} stripeSellerRetrieveSetupIntentRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sellerStripeRetrieveSetupIntentCreate(stripeSellerRetrieveSetupIntentRequest: StripeSellerRetrieveSetupIntentRequest, aaSource?: string, options?: any): AxiosPromise<StripeSetupIntent> {
            return localVarFp.sellerStripeRetrieveSetupIntentCreate(stripeSellerRetrieveSetupIntentRequest, aaSource, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for sellerStripeCreateSetupIntentCreate operation in SellerStripeApi.
 * @export
 * @interface SellerStripeApiSellerStripeCreateSetupIntentCreateRequest
 */
export interface SellerStripeApiSellerStripeCreateSetupIntentCreateRequest {
    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof SellerStripeApiSellerStripeCreateSetupIntentCreate
     */
    readonly aaSource?: string
}

/**
 * Request parameters for sellerStripeRetrieveSetupIntentCreate operation in SellerStripeApi.
 * @export
 * @interface SellerStripeApiSellerStripeRetrieveSetupIntentCreateRequest
 */
export interface SellerStripeApiSellerStripeRetrieveSetupIntentCreateRequest {
    /**
     * 
     * @type {StripeSellerRetrieveSetupIntentRequest}
     * @memberof SellerStripeApiSellerStripeRetrieveSetupIntentCreate
     */
    readonly stripeSellerRetrieveSetupIntentRequest: StripeSellerRetrieveSetupIntentRequest

    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof SellerStripeApiSellerStripeRetrieveSetupIntentCreate
     */
    readonly aaSource?: string
}

/**
 * SellerStripeApi - object-oriented interface
 * @export
 * @class SellerStripeApi
 * @extends {BaseAPI}
 */
export class SellerStripeApi extends BaseAPI {
    /**
     * Returns setup intent, along with the customer and an ephemeral key
     * @summary Creates a new setup intent
     * @param {SellerStripeApiSellerStripeCreateSetupIntentCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SellerStripeApi
     */
    public sellerStripeCreateSetupIntentCreate(requestParameters: SellerStripeApiSellerStripeCreateSetupIntentCreateRequest = {}, options?: any) {
        return SellerStripeApiFp(this.configuration).sellerStripeCreateSetupIntentCreate(requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the SetupIntent and attached PaymentMethod.
     * @summary Gets the details of a setup intent
     * @param {SellerStripeApiSellerStripeRetrieveSetupIntentCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SellerStripeApi
     */
    public sellerStripeRetrieveSetupIntentCreate(requestParameters: SellerStripeApiSellerStripeRetrieveSetupIntentCreateRequest, options?: any) {
        return SellerStripeApiFp(this.configuration).sellerStripeRetrieveSetupIntentCreate(requestParameters.stripeSellerRetrieveSetupIntentRequest, requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }
}
